import React, { Component, useMemo, useState, useEffect } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import './App.css';
import CSVTemplate from './Format.csv';

// eslint-disable-next-line
import Logo from "./header-logo-dark.png";
import InstructionGraphic from './sassy_workflow.png';

import SASSYSegmentPieChart from './components/SASSYSegmentPieChart';
import PlotlyComparisonColumnChart from './components/PlotlyComparisonColumnChart';

import SASSYStatisticsBlock from './components/SASSYStatisticsBlock';
import CSVUploader from './components/CSVUploader';
import UserInfoDialog from './components/UserInfoDialog';

import {
  MaterialReactTable,
  useMaterialReactTable
} from 'material-react-table';

import "./app.demo";

const theme = createTheme({
  palette: {
    primary: { main: "#00688b" },
    secondary: { main: "#cd8500" }
  }
});

export const data = [
  { "casenumber": "11569", "important": "Very important", "worry": "Somewhat worried", "personal": "Only a little", "future": "A great deal", "segment": "Alarmed" },
];

export const defaultColumns = Object.keys(data[0]).map(k => {
  return { accessorKey: k, header: k.toUpperCase(), size: 150 }
})


// Our app
class App extends Component {
  constructor () {
    super();
    this.state = {
      files: [CSVTemplate],
      data: {},
      assetUrl: null,
      allowTableInteractions: false,
      pdfLink: "",
      showUploader: true
    };
    window.reviveState = this.reviveState;
  }

  onResults = ({ data, assetUrl, stats = {} }) => {
    this.setState({ data, assetUrl, stats }, this.requestPDF);
    // this.logDatasetSize();
    // this.requestPDF();
  }

  onRemoveFiles = ({ data, assetUrl = "", files = [], stats = {} }) => {
    this.setState({ data, assetUrl, files, stats });
  }

  logDatasetSize = () => {
    let { data: { resultRows }, stats } = this.state;
    window.dataLayer.push({ "event": "SASSYGroupDataset", "DataSize": resultRows.length, "Statistics": stats });
  }

  requestPDF = () => {
    // var xhr = new XMLHttpRequest();
    // xhr.withCredentials = false;
    // xhr.responseType = "blob";
    var component = this;

    // xhr.addEventListener("readystatechange", function () {
    //   if (this.readyState === this.DONE) {
    //     try {
    //       let objectURL = window.URL.createObjectURL(this.response, { type: "application/pdf" });
    //       component.setState({ pdfLink: objectURL });
    //     } catch (err) {
    //       console.error(err);
    //     }
    //   }
    // });

    let cloudURL = 'https://us-east1-ypccc-tools.cloudfunctions.net/createPDF';

    // xhr.open("POST", `${cloudURL}?url=https://storage.googleapis.com/dataviz.ypccc.tools/sassy-group-scoring/index.html`);
    // xhr.setRequestHeader("content-type", "application/json");

    let req = fetch(`${cloudURL}`, {
      method: "POST", // or 'PUT'
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(Object.assign(component.state.data, { filename: component.uploader.pond.getFile().filenameWithoutExtension })),
    }).then(r => r.blob()).then(response => {
      try {
        let objectURL = window.URL.createObjectURL(response, { type: "application/pdf" });
        component.setState({ pdfLink: objectURL });
      } catch (err) {
        console.error(err);
      }
    }).then(console.log);

  }

  reviveState = (resultData) => {
    this.setState({ data: resultData, showUploader: false });
  }

  render() {
    let { assetUrl, data: { resultHeaders, resultRows = [], stats }, showUploader } = this.state;
    let { allowTableInteractions } = this.state;
    let resultColumns = defaultColumns;
    if (resultHeaders) {
      resultColumns = resultHeaders.map(k => {
        return { accessorKey: k.prop, header: k.label.toUpperCase().slice(0, 40), size: 150 }
      })
    }
    return (
      <ThemeProvider theme={theme}>
        <div className="App">
          <CssBaseline />
          <header className="App-header">
            <h2 className="App-title">SASSY Group Scoring Tool</h2>
          </header>
          <main>
            {(!resultRows || resultRows.length < 1) &&
              <div className="instructions">
                <div>
                  The Six Americas Super Short SurveY (SASSY) Group Scoring Tool allows you to score an entire group and compare the results to national averages.
                </div>
                <br /><br />
                <img className="instruction-graphic" src={InstructionGraphic} alt="Illustration of tool usage"></img>
                <br /><br />
                <span>Download a <a href={process.env.PUBLIC_URL + "/SampleDataset.csv"} target="_blank" rel="noopener noreferrer">CSV template for groups</a> and then upload (or drag and drop) into the box below to see how it works.</span>
              </div>
            }
            {/* Pass FilePond properties as attributes */}
            <CSVUploader hidden={!showUploader} ref={ref => this.uploader = ref} files={this.state.files} onResults={this.onResults} onRemove={this.onRemoveFiles}></CSVUploader>
            {(resultRows && resultRows.length > 0) ? <Paper className="results-container" square style={{ boxShadow: '8px 8px 0 rgba(0, 0, 0, 0.1)', padding: '40px' }}>
              <h1>Six Americas Super Short Survey</h1>
              <h2>Group Data</h2>
              <h3>Audience Segmentation</h3>
              <div className="charts">
                <SASSYSegmentPieChart data={stats}></SASSYSegmentPieChart>
              </div>
              <SASSYStatisticsBlock stats={stats}></SASSYStatisticsBlock>
              <PlotlyComparisonColumnChart data={stats}></PlotlyComparisonColumnChart>
              <div><Typography variant="subheading" className="datatable-heading" gutterBottom align="center">
                Computed Data
              </Typography>
              </div>
              <div className="table-container">
                <MaterialReactTable className="result-table" columns={resultColumns || defaultColumns} data={resultRows} enableRowSelection={allowTableInteractions} enableTopToolbar={allowTableInteractions} enablePagination={allowTableInteractions} enableFiltering={allowTableInteractions} enableSorting={allowTableInteractions} enableColumnActions={allowTableInteractions} enableGrouping={allowTableInteractions} ></MaterialReactTable>
              </div>
              <div className="cta-bar">
                <UserInfoDialog assetUrl={assetUrl} pdfLink={this.state.pdfLink} filename={this.uploader.pond.getFile() ? this.uploader.pond.getFile().filenameWithoutExtension : "SampleDataset"}></UserInfoDialog>
              </div>
            </Paper> : ''}
          </main>
        </div>
      </ThemeProvider>
    );
  }
}

export default App;
